import { toUTCDate } from "src/utils/date";

export const getStartDate = (yearMonth: string): Date =>
  toUTCDate(`${yearMonth}-01`);

export const getMonthFromDate = (date: Date): string =>
  date.toISOString().substring(0, 7);

export const getMonth = (year: number, zeroBasedIndex: number): string =>
  getMonthFromDate(new Date(Date.UTC(year, zeroBasedIndex, 1)));

export const getDateFromMonth = (zeroBasedIndex: number): Date =>
  new Date(Date.UTC(1970, zeroBasedIndex, 1));

export const getYears = (
  minMonth: string,
  maxMonth: string
): number[] | undefined => {
  if (!minMonth || !maxMonth) return undefined;
  const startYear = getStartDate(minMonth).getUTCFullYear();
  const endYear = getStartDate(maxMonth).getUTCFullYear();
  const years: number[] = [];
  for (let year = startYear; year <= endYear; year++) years.push(year);
  return years;
};
export const generateRange = (length: number): number[] =>
  Array.from(Array(length).keys());
